import { Divider } from "@ui-kitten/components";
import { SimplePlanPackageDetails, TicketCartDetails } from "features/types";
import React from "react";
import { View } from "react-native";
import { formatCurrency } from "utils/appUtils";
import { getAllItemsPrice } from "../helpers";
import FeeDetails from "./FeeDetails";
import PriceText from "./PriceText";

const PriceDetails: React.FC<{
  charge: TicketCartDetails;
  refundDetails?: TicketCartDetails;
  planPackage: SimplePlanPackageDetails;
}> = (props) => {
  const {
    charge: {
      totalCreditCardCharges,
      totalCredits,
      totalPoints,
      totalPrice,
      priceType,
      feeItems,
    },
    planPackage,
  } = props;

  // Normal checkout flow, no seat exchanges
  return (
    <View>
      <PriceText
        label="Subtotal"
        text={getAllItemsPrice(props.charge, priceType)}
      />
      {feeItems && feeItems.length > 0 && <FeeDetails feeItems={feeItems} />}
      <PriceText
        label="Total"
        text={formatCurrency(totalPrice, { priceType })!}
      />
      <Divider style={{ marginVertical: 5 }} />
      {/* remaining balance */}
      {/* <RemainingBalance charge={props.charge} /> */}
      {/* NOTE: totalCreditCardCharges, and totalCredits should always be displayed as dollars, 
    regardless of the priceType attribute. */}
      {Number(totalPoints) > 0 && (
        <PriceText
          label="Funds on Account"
          text={`(${formatCurrency(totalPoints, {
            priceType: priceType,
          })!})`}
          textColor="rgb(26, 142, 14)"
        />
      )}
      {Number(totalCredits) > 0 && (
        <PriceText
          label="Account Credit"
          text={`(${formatCurrency(totalCredits)!})`}
          textColor="rgb(26, 142, 14)"
        />
      )}
      <PriceText
        label="Amount to be charged"
        text={formatCurrency(totalCreditCardCharges)!}
        fontWeight="700"
      />
    </View>
  );

  // Seat exchange checkout flow
  // const {
  //   refundDetails: {
  //     totalCreditCardCharges: refundTotalCreditCardCharges,
  //     totalPoints: refundTotalPoints,
  //     priceType: refundPriceType,
  //   },
  // } = props;
  // const hasBalanceRefund = Number(refundTotalPoints) > 0;
  // const hasCreditCardRefund = Number(refundTotalCreditCardCharges) > 0;
  // const hasBalanceCharge = Number(totalPoints) > 0;
  // const hasCreditCardCharge = Number(totalCreditCardCharges) > 0;

  // const shouldShowPaymentDetails =
  //   hasBalanceRefund ||
  //   hasCreditCardRefund ||
  //   hasBalanceCharge ||
  //   hasCreditCardCharge;

  // return (
  //   <View>
  //     {shouldShowPaymentDetails && (
  //       <>
  //         <Pressable onPress={() => setExpanded(!expanded)}>
  //           <Text status="info" style={{ textAlign: "right" }}>
  //             {expanded ? "Hide" : "Show"} Payment Details
  //           </Text>
  //         </Pressable>
  //         {expanded && (
  //           <View className="py-2">
  //             {hasBalanceRefund && (
  //               <PriceText
  //                 label="Amount Refunded to Balance"
  //                 text={formatCurrency(refundTotalPoints, {
  //                   priceType: refundPriceType,
  //                 })}
  //               />
  //             )}
  //             {hasCreditCardRefund && (
  //               <PriceText
  //                 label="Amount Refunded to CC"
  //                 text={formatCurrency(refundTotalCreditCardCharges)}
  //               />
  //             )}
  //             {hasBalanceCharge && (
  //               <PriceText
  //                 label="Amount Funded from Balance"
  //                 text={formatCurrency(totalPoints, {
  //                   priceType: priceType,
  //                 })}
  //               />
  //             )}
  //             {hasCreditCardCharge && (
  //               <PriceText
  //                 label="Amount Funded from CC"
  //                 text={formatCurrency(totalCreditCardCharges)}
  //               />
  //             )}
  //           </View>
  //         )}
  //       </>
  //     )}
  //   </View>
  // );
};

export default PriceDetails;
